export const SET_DATA = "SET_DATA";
export const CLEAR_DATA = "CLEAR_DATA";
export const RESET_TO_BLANK = "RESET_TO_BLANK";
